// extracted by mini-css-extract-plugin
export default {"title":"VkF4EMlM1V5jpvs3szLI","subtitle":"IpKR92Cww5zOU28EA5o6","button":"Ox_BCXr1W1RV85iTBwtW","descriptionInfo":"V8roWF40lHMKs9fxVzut"};